// @flow

import {
  CLEAR_MYQUESTS,
  FETCH_MYQUESTS_REQUEST,
  FETCH_MYQUESTS_FAILURE,
  FETCH_MYQUESTS_SUCCESS,
  DECREMENT_FEEDBACK_COUNT,
  SET_UNREAD_FEEDBACK_COUNT,
  SET_LAST_SKILL_ASSESSMENT_AT
} from '../actions/myquests'

import {
  MENTOR_APPROVED_ACTIVITY,
  MENTOR_REJECTED_ACTIVITY
} from '../actions/activity'

const initialState: {
  isFetching: boolean,
  items: Array<Object>,
  completedItems: Array<Object>,
  unreadFeedbackCount: number
} = {
  isFetching: false,
  items: [],
  completedItems: [],
  unreadFeedbackCount: 0
}

export function myquests(state: Object = initialState, action: Object): Object {
  switch (action.type) {
    case SET_LAST_SKILL_ASSESSMENT_AT: {
      const completedItems = state.completedItems.slice(0)
      const myQuest = completedItems.find(
        q => q.id === action.userCompiledQuestId
      )

      if (myQuest) {
        myQuest.last_skill_assessment_at = Date.now()
      }

      return Object.assign({}, state, {
        completedItems
      })
    }

    case DECREMENT_FEEDBACK_COUNT:
      return Object.assign({}, state, {
        unreadFeedbackCount: state.unreadFeedbackCount - 1
      })

    case SET_UNREAD_FEEDBACK_COUNT:
      return Object.assign({}, state, {
        unreadFeedbackCount: action.count
      })

    case MENTOR_APPROVED_ACTIVITY: {
      const items = state.items.slice(0)
      const myQuest = items.find(
        q => q.current_user_quest_activity_id === action.activityId
      )

      if (myQuest) {
        myQuest.new_feedback_available = true
        myQuest.awaiting_approval = false
        myQuest.current_user_quest_activity.approved_at = Date.now()
      }

      return Object.assign({}, state, {
        items: items
      })
    }

    case MENTOR_REJECTED_ACTIVITY: {
      const items = state.items.slice(0)
      const myQuest = items.find(
        q => q.current_user_quest_activity_id === action.activityId
      )

      if (myQuest) {
        myQuest.new_feedback_available = true
        myQuest.awaiting_approval = false
        myQuest.current_user_quest_activity.disapproved_at = Date.now()
      }

      return Object.assign({}, state, {
        items: items
      })
    }

    case CLEAR_MYQUESTS:
      return Object.assign({}, state, {
        items: [],
        completedItems: []
      })

    case FETCH_MYQUESTS_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case FETCH_MYQUESTS_SUCCESS:
      return Object.assign(
        {},
        state,
        action.fetchActive
          ? {
              isFetching: false,
              items: action.myquests
            }
          : {
              isFetching: false,
              completedItems: action.myquests
            }
      )

    case FETCH_MYQUESTS_FAILURE:
      return Object.assign(
        {},
        state,
        action.fetchActive
          ? {
              isFetching: false,
              items: []
            }
          : {
              isFetching: false,
              completedItems: []
            }
      )

    default:
      return state
  }
}
